<!--文献资料-->
<template>

  <div class="common-container">
    <div class="background"></div>
    <Header></Header>
    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
            <el-col :xs="22" :sm="22" :md="22" :lg="20" :xl="20">
              <el-row class="middle">
                <el-col class="middleRight">
                  <el-row type="flex" justify="center">
                    <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
                      <literature-aside></literature-aside>
                    </el-col>
                    <el-col :xs="0" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="literature-info-box">
                        <div class="literature-info-title" v-text="nowTypeName"></div>
                        <div class="literature-info-text">

                            <div class="literature-info-text-item" v-for="(item,index) in fileList">
                              <span class="literature-info-text-item-index">({{index+1}})</span>
                              <span class="literature-info-text-item-link" @click="goPdf(item.file_path)" v-text="item.file_name">
                              </span>
                            </div>


                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        fileList:[],
        typeList:[],
        nowTypeName:null,




      };
    },

    components: {},

    mounted() {
      this.getFileList();
      this.getTypeList();
    },

    watch: {
      //监听相同路由下参数变化
      '$route'(to, from) {
          this.getTypeList();
          this.getFileList();
        //每当参数变化时重新获取数据

      }
    },

    methods: {
      getFileList()
      {
        this.instance.get('/api/data/getfilelist',{
          params:{
            type:this.$route.query.id,
            // page:1,
          }
        }).then(res=>{
          if(res.status==200)
          {
            this.fileList = res.data.filelist
          }
          else
          {
            return false
          }
        })
      },

      getTypeList() {
        this.instance.get('/api/data/gettypelist').then(res => {
          if (res.status == 200) {
            let typeList = res.data.typelist
            this.typeList = typeList
            if(this.$route.query.id==undefined)
            {
              this.$router.push({path:'/literature',query: {id:typeList[0].id}})
            }
            else
            {
              typeList.forEach(item=>{
                if(item.id==this.$route.query.id)
                {
                  this.nowTypeName = item.type
                }
              })
            }


          }
        })
      },




      goPdf(path){
        window.location.href =  'https://' + path
      },



    },

  }

</script>
<style scoped>
  .common-main-artical {
    height: 700px;
  }

  .downloadbtn {
    margin: 20px 0;
  }

  .downloadbtn>span {
    width: 45px;
    text-align: center;
    display: inline-block;
  }

  .downloadbtn>p {
    color: #2C90FF;
    cursor: pointer;
    /* width: 1000px; */
    /* width: 100%; */
    width: 100%;
    display: inline-block;
    text-decoration: underline;
  }


</style>



// WEBPACK FOOTER //
// src/views/Literature.vue